import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=22e1bc83&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e1bc83')) {
      api.createRecord('22e1bc83', component.options)
    } else {
      api.reload('22e1bc83', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=22e1bc83&", function () {
      api.rerender('22e1bc83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/Index.vue"
export default component.exports